import app from './app';
import auth from './auth';
import footer from './footer';
import form from './form';
import juma from './juma';
import landing from './landing';
import store from './store';
import system from './system';
import validations from './validations';

export default { footer, auth, system, form, juma, app, landing, store, validations };
